export const urlBase = 'https://www.scrumbill.com/'
export const apiBase = urlBase +'api/'
export const printBase = urlBase +'print/'
export const uiBase  = '/'

export const spaceID = 'QKVOrpRqU5QV3ecvAg76mSD28idd5XWK'

export const messagesType = 'IrscmyYKLt1lvqxbxauDpyhW9aZiuZIU'
export const relNotesType = 'TDqhKALIeyULhkLMdmPV06dLaQbvA46H'
